import { Link, useMatch, useResolvedPath } from "react-router-dom";



function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
  
    return (
      <div className="py-2">
        <Link
          style={{ textDecoration : "none" , border: match? "2px solid white" : "none", padding: match?"5px" : "", color : match? "yellow" : "white", borderRadius : match? "5px" :"" }
        
        
        
        }
          to={to}
          {...props}
        >
          {children}
        </Link>
       
      </div>
    );
  }
  export default CustomLink